export default __webpack_public_path__ + "static/media/x1.687c6521.png";